import React from "react";
import { Button } from "semantic-ui-react";
import { Mutation } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import { ME_USER_QUERY } from "@/graphql/queries/users";
import { CSSTransition } from "react-transition-group";
import { StyledAnimatedButton } from "./FavoriteButton";
import Translator from "@/components/hoc/Translator";

const USER_ADD_FAVORITE_MUTATION = gql`
  mutation USER_FAVORITE_STATUS_QUERY($jobId: ID!) {
    addFavorite(job: $jobId)
  }
`;

const update = (cache, payload) => {
  const jobId = payload.data.addFavorite;
  try {
    const data = cache.readQuery({
      query: ME_USER_QUERY,
    });

    if (!data?.me) return;
    const already = (data.me.favorites || []).some(
      (favorite) => favorite.job?.id === jobId
    );
    cache.writeQuery({
      query: ME_USER_QUERY,
      data: {
        me: {
          ...data.me,
          favorites: already
            ? data.me.favorites
            : [
                ...(data.me.favorites || []),
                {
                  __typename: "Favorite",
                  id: "TempId-" + jobId,
                  job: { __typename: "Job", id: jobId },
                },
              ],
        },
      },
    });
  } catch (err) {
    return;
  }
};

const favoriteButtonWrapper = ({
  jobId,
  show,
  count,
  loading,
  compact,
  inFlow,
}) => {
  return (
    <Mutation
      mutation={USER_ADD_FAVORITE_MUTATION}
      variables={{ jobId }}
      update={update}
      optimisticResponse={{
        __typename: "Mutation",
        addFavorite: jobId,
      }}
    >
      {(userAddFavoriteMutation, { data, error, called }) => {
        if (error) return <p>Error</p>;
        return (
          <CSSTransition
            unmountOnExit
            in={show}
            className="AddFavorite"
            key={jobId + "Add"}
            timeout={{ enter: 300, exit: 300 }}
          >
            <StyledAnimatedButton
              className="AnimatedButton"
              $inFlow={!!(compact || inFlow)}
            >
              <Button
                color="grey"
                content={<Translator>Like</Translator>}
                icon="heart"
                size={compact ? "mini" : "small"}
                compact={!!compact}
                loading={loading}
                label={{
                  basic: true,
                  color: "grey",
                  pointing: "left",
                  content: count,
                  size: "mini",
                }}
                onClick={userAddFavoriteMutation}
              />
            </StyledAnimatedButton>
          </CSSTransition>
        );
      }}
    </Mutation>
  );
};

export default favoriteButtonWrapper;
